<template>
	<div style="height: 100vh;" v-if="this.$store.state.isAuthenticated && $route.name != 'Reestablecer' && $route.name !== 'Register'">
		<Header v-if="$store.state.showNavbar"/>
		<v-container fluid class="grey lighten-4 py-0" style="height: calc(100vh - 76px);">
			<v-row class="fill-height">
				<v-col v-if="!$vuetify.breakpoint.mobile" cols="3" class="py-0 pl-0" style="max-height: 100%;">
					<SidebarContent />
				</v-col>
				<v-navigation-drawer
						v-else
						v-model="$store.state.drawer"
						absolute
						top
						temporary
					>
					<SidebarContent />
				</v-navigation-drawer>
				<v-col 
					:cols="$vuetify.breakpoint.mobile ? 12:9"
					class="py-0"
					style="max-height: 100%;"
					:style="!$vuetify.breakpoint.mobile ? '':'overflow-y: scroll;'">
					<router-view></router-view>
				</v-col>
			</v-row>
		</v-container>
	</div>
	<div style="height: 100vh;" v-else>
		<router-view></router-view>
	</div>
</template>

<script>
	import Header from './Header'
	import SidebarContent from './SidebarContent'
	export default {
		name: 'App',
		components: {Header, SidebarContent},
		data: () => ({
		}),
	};
</script>
